// extracted by mini-css-extract-plugin
module.exports = {"SearchItem":"SearchItemForTherapy_SearchItem__lwsQr","IconWrapper":"SearchItemForTherapy_IconWrapper__-sN9m","IconStyle":"SearchItemForTherapy_IconStyle__1-63N"};